// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"99":"1831979733d29aae70a1","703":"65263cd2e2b97800d783","886":"2613cfef6e796d79a96f","954":"f5dfc4a212038611b0cf"}[chunkId] + ".js";
};